import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        contractBasis: {
            paddingBottom: theme.spacing(1),
        },
    }
})

export default useStyles
